<ngx-spinner
	bdColor="rgba(75, 55, 100, 0.5)"
	size="large"
	color="#fff"
	type="line-scale-pulse-out">
	<span class="chevron left"></span>
	<span class="chevron right"></span>
</ngx-spinner>
<div class="m-grid__item m-grid__item--fluid m-wrapper" *ngIf="form">
	<div class="m-content">
		<!--begin::Portlet-->
		<!--begin::Form-->
		<form
		[formGroup]="form"
		*ngIf="form"
		class="m-form m-form--fit m-form--label-align-right">
            <app-location-form
                *ngIf="form"
                formName="CREATE LOCATION"
                [disableForm]="false"
                [disableSelection]="true"
                [parentGroup]="form"
                [locationData]="location">
            </app-location-form>
        </form>

        <div class="form-group m-form__group row">
			<div class="col-lg-12">
				<button [debounceClick] [disabled]="loading" type="submit" (click)="save()" class="btn btn-primary">
				{{ locationId ? "Update" : "Create" }}
				</button>
				<button style="margin-left: 15px;" type="submit" (click)="navigateUp()" class="btn btn-danger">
				Cancel
				</button>
				<div *ngIf="hasValidationErrors">
					<span style="color:red">Please complete the required fields</span>
				</div>
			</div>
		</div>
    </div>
</div>